/* eslint @typescript-eslint/no-explicit-any: 0 */
import React, { forwardRef } from 'react';
import Styled from './Styled';
const Container = forwardRef(({ as: asProp, className, children, onClick, ...config }, ref) => {
    return (React.createElement(Styled.Wrapper, { onClick: onClick, ref: ref, as: asProp, className: className, "$config": config }, children));
});
export default Container;
